"use client"

import { useEffect } from 'react'
import { useSession } from 'next-auth/react'
import { usePathname, useRouter } from 'next/navigation'
import { api } from '@/lib/api'

export default function RequireTwoFactor() {
  const { status } = useSession()
  const pathname = usePathname()
  const router = useRouter()
  useEffect(() => {
    if (status !== 'authenticated') return
    if (!pathname) return
    // Allow the setup route itself without gating
    if (pathname.startsWith('/settings/security')) {
      return
    }
    // Only gate app routes (API routes and assets are already excluded by middleware)
    const token = typeof window !== 'undefined' ? localStorage.getItem('auth.token') : null
    if (!token) return
    ;(async () => {
      try {
        const { data } = await api.get<{ enabled: boolean }>(`/api/auth/2fa/status`)
        if (!data?.enabled) {
          router.replace('/settings/security')
          return
        }
      } catch {
        // If status call fails, allow navigation; backend will still protect sensitive ops
      }
    })()
  }, [status, pathname, router])

  return null
}
